//#region : Imports

import { BrowserModule } from "@angular/platform-browser";

import { NgModule } from "@angular/core";

import { AppComponent } from "./app.component";

import { HeaderComponent } from "./header/header.component";

import { NavComponent } from "./nav/nav.component";

import { MainComponent } from "./main/main.component";

import { AsideComponent } from "./aside/aside.component";

import { FooterComponent } from "./footer/footer.component";

import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";

import { AppRoutingModule } from "./app-routing.module";

import { GlobalsService } from "./globals.service";

import { ComponentsModule } from "./components/components.module";

import { HttpClientModule } from "@angular/common/http";

import { NgxLoadingModule, ngxLoadingAnimationTypes } from "ngx-loading";

import { AngularResizedEventModule } from "angular-resize-event";

import { FormsModule } from "@angular/forms";

import { AdminComponent } from "./components/admin/admin.component";

import { PagesModule } from "./pages/pages.module";

import { BackButtonDisableModule } from "angular-disable-browser-back-button";

import { NgxJsonViewerModule } from "ngx-json-viewer";
import { SidebarModule } from "ng-sidebar";
import { HeaderModule } from "./header/header.module";
import { SafePipe } from "./safe.pipe";
import { ParticlesModule } from "angular-particle";

// import
// {
//     angularTypewrite
// }
// from "src/assets/js/angular-typewrite.js"

//#endregion

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    NavComponent,
    MainComponent,
    AsideComponent,
    FooterComponent,
    PrivacyPolicyComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ComponentsModule,
    PagesModule,
    HttpClientModule,
    AngularResizedEventModule,
    FormsModule,
    SidebarModule.forRoot(),
    NgxJsonViewerModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.wanderingCubes,
    }),
    BackButtonDisableModule.forRoot(),
    ParticlesModule,
    // angularTypewrite
  ],
  providers: [GlobalsService],
  bootstrap: [AppComponent],
})
export class AppModule {}
